// extracted by mini-css-extract-plugin
module.exports = {"Button":"AddToCart_Button__2j_gm","Remove":"AddToCart_Remove__3oOnu"};